/**
 * Create form component pattern for all creation forms inspired by watabi forms structure
 *
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Yii } from "libraries/interfaces/Yii";
import { faTimesCircle, IconDefinition} from "@fortawesome/free-regular-svg-icons";

@Component({
    selector: 'ui-create-form',
    template: `
        <!--  BLOCK CONTAINER-->

        <div class="createFormContainer blockCreateForm"
             [class.fullPage]="fullPage">

            <div class="createFormHeader">
                <div class="formCapContainer"
                     [class.subHeaderContainer]="fullPage">
                    <div class="formCapItem formTitle"
                         [class.subHeaderSide]="fullPage"
                         [class.subHeaderSide-left]="fullPage">
                            <span class="blockNavigationContainer">
                                <span>
                                  {{ formTitle }}
                                </span>
                            </span>
                        <ng-content select=".customTitleArea"></ng-content>
                    </div>
                    <div class="tabNav"
                         [class.subHeaderNav]="fullPage"
                         *ngIf="formMode == 'multiTab'">
                        <ul class="linkList">
                            <ng-content select=".navLinkItem"></ng-content>
                        </ul>
                    </div>
                    <span [class.subHeaderSide]="fullPage"
                          [class.subHeaderSide-right]="fullPage">
          <div class="buttonGroup buttonGroup-endPosition">
            <button type="button"
                    class="plainButton closeButton tooltipParent"
                    (click)="closeForm()">
                <fa-icon [icon]="iconTimesCircle"></fa-icon>
                {{ closeLabel ? closeLabel : t_close }}
                <div class="tooltip">{{ closeLabel ? closeLabel : t_close }}</div>
            </button>
          </div>
        </span>
                </div>
                <div class="fieldContainer">
                    <div class="blockSearchContainer">
                        <ng-content select=".blockSearchField"></ng-content>
                        <div class="buttonGroup buttonGroup-endPosition">
                            <ng-content select=".plainButton"></ng-content>
                        </div>
                    </div>
                    <ng-content select=".blockSearchContainer"></ng-content>
                    <ng-content select=".categoryTogglerContainer"></ng-content>
                </div>
            </div>
            <!-- BLOCK MAIN AREA -->
            <ng-content class="blockResultsContainer"></ng-content>
        </div>  <!-- END OF BLOCK MAIN AREA -->
    `,
    styles: [ `
        .createFormHeader .formCapContainer .formCapItem.formTitle {
            display: flex;
        }

        .formCapItem.formTitle.subHeaderSide {
            font-weight: normal;
            font-size: 13px
        }
    ` ]
})

export class CreateFormComponent {

    @Input()
    public noCategoryList: boolean = false;
    @Input()
    public formTitle: string = "";
    @Input()
    public closeLabel: string;

    /*
    * @formMode allows to choose new behaviours on form
    * ex => 'multiTab' formMode adds a navigation area on top
    */
    @Input()
    public formMode: string = "plainForm";

    /*
    * @fullpage allows to allows the form to take all the page place
    */
    @Input()
    public fullPage: boolean = false;

    @Output()
    public closeActionCall: EventEmitter<boolean> = new EventEmitter();

    // translated strings :

    public t_noResults = Yii.t('wui-shared-js', 'Aucun résultat trouvé');
    public t_seeMore = Yii.t('wui-shared-js', 'En voir plus');
    public t_close = Yii.t('wui-shared-js', 'Fermer');
    public iconTimesCircle: IconDefinition = faTimesCircle;

    public closeForm(): void {
        this.closeActionCall.emit(true);
    }


}
